const nsi = '/api/nsi';

export default {
  directives: {
    countries: '/api/country/search',
    groupsCountries: '/api/countrygroup/search',
    typeOfTradingOperation: `${nsi}/nsitradingoperation/search`,
    transport: `${nsi}/nsitransport/search`,
    typeImport: '/api/prioritydestinationimport/importkind',
    processType: `${nsi}/nsinavigatorprocesstype/search`,
    procedure: '/api/procedure/search',
    operations: '/api/step/search',
    nsiCountryWithData: `${nsi}/countryListWithData`,
    nsiCountry: `${nsi}/countryList`,
    nsiMeasureOrganProtectedMarketSearch: `${nsi}/nsimeasureorganprotectedmarket/search`,
    nsiIndustry: `${nsi}/nsiindustry/search`,
    nsiMoveDirections: `${nsi}/moveDirections`,
    nsiCountryCoverages: `${nsi}/countryCoverages`,
    nsiMeasureTypes: `${nsi}/measureTypes`,
    nsiRequestTtrStatus: `${nsi}/nsirequestttrstatus/search`,
    nsiMpkBusinessStatus: `${nsi}/nsimpkbusinessstatus/search`,
    nsiInvestigationType: `${nsi}/nsiinvestigationtype/search`,
    nsiFreeTradeAgreementType: `${nsi}/NsiFreeTradeAgreementType/search`,
    regions: '/api/FERDictionaries/GetRFRegions',
    chinaProvinces: '/api/ferdictionaries/getchinaprovinces',
    partnerCountry: '/api/FERDictionaries/GetCountries',
    federalDistricts: '/api/ferdictionaries/getfederaldistricts',
    publicNavigationMenu: '/api/menu/menu',
    getOrganizationList: '/api/organization/search',
  },
  nsitnved: {
    search: `${nsi}/nsitnved/search`,
    byIDs: `${nsi}/nsitnved/listbyids`,
  },
  investmentAgreement: {
    getList: '/api/investmentagreement/search',
    find: '/api/investmentagreement/find',
    CRUD: '/api/investmentagreement',
  },
  countryAnalytics: {
    payments: {
      currentBalance: '/api/BalanceOfPayment/CurrentAccountAndComponentsItems',
      financialBalance: '/api/BalanceOfPayment/FinancialAccountAndComponentsItems',
      infoCurrentBalance: '/api/balanceofpayment/currentaccountandcomponentsvalues',
      infoFinancialBalance: '/api/balanceofpayment/financialaccountandcomponentsvalues',
      infoReserveAssetBalance: '/api/balanceofpayment/reserveassetbalancevalues',
      infoPureErrorsAndOmissions: '/api/balanceofpayment/pureerrorsandomissionsvalues',
      yearList: '/api/balanceofpayment/getyearlist',
    },
    priorityImportAndImportDestination: {
      getInfo: '/api/prioritydestinationimport/search',
      loadFile: '/api/prioritydestinationimport/upload',
    },
    analytics: {
      getLifeIndexSummary: 'api/lifeindex/summary',
      getInvestmentInStock: 'api/investment/instock',
      getInvestmentOutStock: 'api/investment/outstock',
      getInvestmentInFlows: 'api/investment/inflows',
      getInvestmentOutFlows: 'api/investment/outflows',
      getForeignTradeTurnoverWordBalance: 'api/foreigntradeturnoverworld/balance',
      getForeignTradeTurnoverWordGdpValues: 'api/foreigntradeturnoverworld/gdpvalues',
      getUnfriendlyCountryInfo: 'api/unfriendlyCountries/unfriendlyCountryInfo',
      getTopImportIndustries: 'api/foreigntradeturnoverworld/top5importindustries',
      getTopExportIndustries: 'api/foreigntradeturnoverworld/top5exportindustries',
      getTopImportCountries: 'api/foreigntradeturnoverworld/top5importcountries',
      getTopExportCountries: 'api/foreigntradeturnoverworld/top5exportcountries',
      getIndicatorBudgetDeficit: 'api/keyindicators/budgetdeficit',
      getIndicatorStockMarketCapitalization: 'api/keyindicators/stockmarketcapitalization',
      getIndicatorFinancialAccount: 'api/keyindicators/financialaccount',
      getIndicatorGovernmentBondYields: 'api/keyindicators/governmentbondyields',
      getYearListTurnover: 'api/foreignTradeTurnoverWorld/yearList',
      getForeignTradeData: 'api/foreigntrade/summary',
      getMacroEconomicIndicatorValue: 'api/macroeconomicindicatorcountryvalue/search',
      getEconomicReviewSummary: 'api/economicsReview/summary',
      getIndicatorCountryRating: 'api/keyindicators/countryratings',
      getExportProductLast: 'api/exportProduct/summaryLast',
      getFerRegionsTradeValue: 'api/ferregionstrade/getvalue',
      getFerRegionsTradeCountryCount: 'api/ferregionstrade/getcountrycount',
      getQuartalList: 'api/favortrade/getquartallist',
      getQuartalSummary: '/api/favortrade/getquartalsummary',
    },
    exportPotential: {
      search: '/api/exportpotential/search',
    },

    importPotential: {
      search: '/api/importpotential/search',
    },
  },
  navigator: {
    productGroups: {
      search: '/api/grouptnvedftt/search',
      find: '/api/grouptnvedftt/find',
      CRUD: '/api/grouptnvedftt',
    },
    scenarios: {
      search: '/api/scenario/search',
    },
    stepCards: {
      getStepCard: '/api/step/find/',
      saveStepCard: '/api/step',
      getDocumentList: '/api/navigatordocument/search',
      getLegalSourceList: '/api/legalsource/search',
    },
  },
  importAnalytics: {
    getUnfriendlyCountriesSearch: '/api/unfriendlycountries/search',
    loadUnfriendlyCountriesReport: 'api/unfriendlycountries/uploaddata',
    keyCountryIndicator: {
      getIndicators: '/api/FERDashboard/getindicatortypecountries',
      getCountriesList: '/api/FERDashboard/getkeyindicatorcountriestable',
    },
    indicatorLoadMonitoring: {
      getIndicators: '/api/monitoringindicator/indicators',
      getUpdateStatuses: '/api/monitoringindicator/update-statuses',
      getSources: '/api/monitoringindicator/sources',
      getExpiredIndicator: '/api/monitoringindicator/summary',
      getReports: '/api/monitoringindicator/reports',
    },
  },
  measure: {
    singleTtrRegistry: {
      CRUD: '/api/singlettr',
      changeParametersMulti: '/api/singlettr/changeparametersmulti',
      findAuditLog: '/api/singlettraudit/findauditlog',
    },
    unilateralNonTrRegistry: {
      CRUD: '/api/unilateralnontr',
      changeParametersMulti: '/api/unilateralnontr/changeparametersmulti',
      findAuditLog: '/api/unilateralnontraudit/findauditlog',
    },
    initiativeRegistry: {
      changeParametersMulti: '/api/requestinitiativettr/changestatusmulti',
    },
  },
  ves: {
    getYearFirst: '/api/ferdictionaries/getfirstdatayear',
    events: {
      getCombined: '/api/fereventsved/getcombinedevents',
      create: '/api/fereventsved/create',
      update: '/api/fereventsved',
      delete: '/api/fereventsved',
      getById: '/api/fereventsved',
      getEventCard: '/api/ferregionsanalytics/getevent',
      downloadExcel: '/api/ferregionsanalytics/exporteventstoexcel',
      downloadPDF: '/api/ferregionsanalytics/exporteventtopdf',
      getAgreementTypes: '/api/ferregionsanalytics/getagreementtypes',
      getIndicatorCards: '/api/ferregionsanalytics/geteventsstatistic',
    },
    economicRelations: {
      getPassportKeyData: 'api/ferpassportkeydata/get',
      getPassportPartnerCountriesData: 'api/ferpassportpartnercountries/getdata',
      getPassportPartnerCountriesCount: 'api/ferpassportpartnercountries/getpartnerscount',
      getPassportTradeTurnover: 'api/ferpassporttradeinfo/getturnover',
      getPassportMainData: 'api/ferpassportmaindata/getmaindata',
      getPassportCurrentEvents: 'api/ferpassportevents/getcurrentevents',
      getPassportPreviousEvents: 'api/ferpassportevents/getpreviousevents',
      getPassportCurrentEventsCount: 'api/ferpassportevents/getcurrenteventscount',
      getPassportPreviousEventsCount: 'api/ferpassportevents/getpreviouseventscount',
      getPassportAgreements: 'api/ferpassportagreements/getagreements',
      getResponsibleAuthority: 'api/ferresponsibleauthority/getresponsibleauthority',

      topRegionsAgreements: '/api/fergeneralinfo/getregionsstatistic',
      topEfficiency: '/api/fergeneralinfo/gettopeffectiveregions',
      topRegionsByTurnover: '/api/fergeneralinfo/gettopregionsbyturnover',
      topRegionsByExport: '/api/fergeneralinfo/gettopregionsbyexport',
      topRegionsByImport: '/api/fergeneralinfo/gettopregionsbyimport',
      topRegionsByEvents: '/api/fergeneralinfo/gettopregionsbyevents',
      topRegionsByAgreements: '/api/fergeneralinfo/gettopregionsbyagreements',
      topMonthRegionsByEvents: '/api/fergeneralinfo/getmonthtopregionsbyevents',
      topMonthRegionsByAgreements: '/api/fergeneralinfo/getmonthtopregionsbyagreements',
    },
    implementation: {
      getEventsHistory: '/api/ferhistory/getfilteredeventshistory',
      getAgreementsHistory: '/api/ferhistory/getfilteredagreementshistory',
      exportEvents: '/api/ferhistory/exporteventshistorytoexcel',
      exportAgreements: '/api/ferhistory/exportagreementshistorytoexcel',
    },
    activeAgreements: {
      searchAgreements: '/api/FERDashboard/getagreementstable',
      exportAgreementsExcel: '/api/FERDashboard/exportagreementstoexcel',
      getAgreementsCount: '/api/FERDashboard/getagreementsdatescount',
    },
    projectWithRegions: {
      searchProjects: '/api/FERDashboard/getprojectswithforeignparticipationtable',
      exportProjectsExcel: '/api/FERDashboard/exportprojectswithforeignparticipationtoexcel',
      getProjectsWithForeignParticipationDatesCount: '/api/FERDashboard/getprojectswithforeignparticipationdatescount',
    },
    projectWithNations: {
      searchProjects: '/api/FERDashboard/getprojectsinforeigncountriestable',
      exportProjectsExcel: '/api/FERDashboard/exportprojectsinforeigncountriestoexcel',
      getProjectsInForeignCountriesDatesCount: '/api/FERDashboard/getprojectsinforeigncountriesdatescount',
    },
    dashboards: {
      getRegionStatistic: '/api/FERDashboard/getregionsstatistic',
      getTopCountryPartners: '/api/FERDashboard/gettoppartnercountries',
      getTopEffectiveRegions: '/api/FERDashboard/gettopeffectiveregions',
      getTopEffectiveRegionsRating: '/api/FERDashboard/gettopeffectiveregionsrating',
      getBaseRegionInfo: '/api/FERDashboard/getregionbaseinfo',
      getDynamicCards: '/api/FERDashboard/getdynamicindicators',
      getIndicatorTypes: '/api/FERDashboard/getindicatortypes',
      getRatingList: '/api/FERDashboard/gettopeffectiveregionsratingrelative',
      getRatingCards: '/api/FERDashboard/getregionstatistic',
      getEventsCountByTypes: '/api/FERDashboard/geteventscountbytypes',
      getAgreementsCountByTypes: '/api/FERDashboard/getagreementscountbytypes',
      getEventTypes: '/api/ferregionsanalytics/geteventtypes',
      getEventVedTypes: '/api/ferregionsanalytics/geteventvedtypes',
      getEventStatuses: '/api/ferregionsanalytics/geteventstatuses',
      getPlannedEvents: '/api/FERDashboard/getplannedevents',
      getPersonInfo: '/api/FERDashboard/getcountrypersonalinfo',
      getTopRfSubjectsEvents: '/api/FERDashboard/gettopregionsbyevents',
      getTopRfSubjectsGrowthRate: '/api/FERDashboard/gettopregionsbyindicatortype',
      getRepresentativeAbroadInfo: '/api/FERDashboard/getforeignrepresentativeinfo',
      getRepresentativeAbroadInfoTable: '/api/FERDashboard/getforeignrepresentativeeventstable',
      exportregioneffectivnessratingExcel: '/api/ferdashboardexport/exportregioneffectivnessrating',
    },
  },
  ved: {
    common: {
      getRegionsRfTree: '/api/countrysubject/country-subjects-tree',
      getCountriesTree: '/api/countrypartner/getcountriespartnertree',
      getCustomsOrgansOnBorder: '/api/tcustdepartmenttree/getlist',
      getTCustDepartmentTree: 'api/tcustdepartmenttree/gettcustdepartmenttree',
    },
    regionAggregated: {
      getRegionAggregated: '/api/regionsreportbyregion',
      exportExcel: '/api/regionsreportbyregion/exportxlsx',
    },
    productAggregated: {
      getProductAggregated: '/api/regionsreportbytnved',
      exportExcel: '/api/regionsreportbytnved/exportxlsx',
    },
    foreignTrade: {
      regions: {
        getRegionAggregated: '/api/foreigntradebysubjectrf/getdataaggregates',
        exportExcel: '/api/foreigntradebysubjectrf/exportxlsx',
      },
      products: {
        getProductAggregated: '/api/foreigntradebyproducts/getdataaggregates',
        exportExcel: '/api/foreigntradebyproducts/exportxlsx',
      },
      countries: {
        getCountryAggregated: '/api/foreigntradebycountries/getdataaggregates',
        exportExcel: '/api/foreigntradebycountries/exportxlsx',
      },
    },
    analyticsNotes: {
      common: {
        getCountryDeclensions: '/api/countrydeclension/country/declensions',
      },
      monthly: {
        getForeignTradeTable: '/api/monthlyforeigntrade/getforeigntradetable',
        getForeignTrade: '/api/monthlyforeigntrade/getforeigntrade',
        exportExcel: '/api/monthlyforeigntrade/excel',
        getExportStructure: '/api/monthlyforeigntrade/export/structure',
        getImportStructure: '/api/monthlyforeigntrade/import/structure',
        getExportMainGoods: '/api/monthlyforeigntrade/export/main-goods',
        getImportMainGoods: '/api/monthlyforeigntrade/import/main-goods',
      },
      yearly: {
        getForeignTradeTable: '/api/annualforeigntrade/getforeigntradetable',
        getForeignTrade: '/api/annualforeigntrade/getforeigntrade',
        exportExcel: '/api/annualforeigntrade/excel',
        getExportStructure: '/api/annualforeigntrade/export/structure',
        getImportStructure: '/api/annualforeigntrade/import/structure',
        getExportMainGoods: '/api/annualforeigntrade/export/main-goods',
        getImportMainGoods: '/api/annualforeigntrade/import/main-goods',
      },
    },
    annualForeignTrade: {
      getForeignTradeTable: '/api/annualforeigntrade/getforeigntradetable',
      getForeignTrade: '/api/annualforeigntrade/getforeigntrade',
      exportExcel: '/api/annualforeigntrade/excel',
      getExportStructure: '/api/annualforeigntrade/export/structure',
      getImportStructure: '/api/annualforeigntrade/import/structure',
      getExportMainGoods: '/api/annualforeigntrade/export/main-goods',
      getImportMainGoods: '/api/annualforeigntrade/import/main-goods',
    },
    monthlyForeignTrade: {
      getForeignTradeTable: '/api/monthlyforeigntrade/getforeigntradetable',
      getForeignTrade: '/api/monthlyforeigntrade/getforeigntrade',
      exportExcel: '/api/monthlyforeigntrade/excel',
      getExportStructure: '/api/monthlyforeigntrade/export/structure',
      getImportStructure: '/api/monthlyforeigntrade/import/structure',
      getExportMainGoods: '/api/monthlyforeigntrade/export/main-goods',
      getImportMainGoods: '/api/monthlyforeigntrade/import/main-goods',
    },
    userGroups: {
      areas: {
        getCountries: '/api/areas/countries',
        getAreas: '/api/areas',
        getAreaLinks: '/api/areas/countries',
        createArea: '/api/areas',
        updateArea: '/api/areas',
        deleteArea: '/api/areas',
        saveAreaCountries: '/api/areas/countries',
      },
      customs: {
        getItems: '/api/tcustdepartmenttree/gettcustdepartmentlist',
        getLinks: '/api/tcustdepartmenttree',
        createGroup: '/api/tcustdepartmenttree',
        updateGroup: '/api/tcustdepartmenttree',
        deleteGroup: '/api/tcustdepartmenttree',
        saveGroupItems: '/api/tcustdepartmenttree/updatechildrenlinks',
      },
      transport: {
        getGroups: '/api/transport/groups/tree',
        getItems: '/api/transport',
        getLinks: '/api/transport/groups/transport-types-by-id',
        createGroup: '/api/transport/groups',
        updateGroup: '/api/transport/groups',
        deleteGroup: '/api/transport/groups',
        updateRelations: '/api/transport/groups/relations',
      },
      goods: {
        getItems: '/api/tnved',
        getGroups: '/api/tnvedgroups',
        getGroup: '/api/tnvedgroups',
        getLinks: '/api/tnvedgroups/tnved-ids-by-group-id',
        createGroup: '/api/tnvedgroups',
        updateGroup: '/api/tnvedgroups',
        deleteGroup: '/api/tnvedgroups',
        saveConnections: '/api/tnvedgroups/connections-by-group-id',
        getFtsEdizmMeasurementUnits: '/api/ftsedizm/measurement-units-tree',
      },
    },
    fts: {
      common: {
        getCustomsProcedures: '/api/ftsotamreg/procedures-tree',
        getProductsGroups: '/api/tnvedukrup/tnved-ukrup',
        getProductsSigns: '/api/tnvedbylen',
        getOkatoTree: '/api/CountrySubject/country-subjects-flat',
        getCountriesTree: '/api/ftscountry/countries-tree',
      },
      monthly: {
        getTableData: '/api/ftsdatamesreport',
        exportExcel: '/api/ftsdatamesreport/excel',
      },
      weekly: {
        getTableData: '/api/ftsweeklyreport',
        exportExcel: '/api/ftsweeklyreport/excel',
        getDeliveryTerms: '/api/meruslpost',
        getTransportTypes: '/api/mervidtrans',
        getDeliveryGoodsPoints: '/api/dictdeliverypoint',
        getExporters: '/api/dictexporter',
      },
    },
  },
  crossCuttingTask: {
    getCrossCuttingTasksMpk: '/api/crosscuttingtask/tasksforcochairmanmpk',
  },
  mpkProject: {
    getMpkProjectDepartment: '/api/department/search',
    getMpkProjectMinRole: '/api/nsi/getnsiminroles',
    getMpkProjectList: '/api/nsi/getnsiprojectlists',
    getMpkProjectSupportMeasure: '/api/nsi/getnsisupportmeasures',
    getMpkProjectCategoryList: '/api/nsi/getnsiprojectcategories',
    getMpkProjectTypeEntry: '/api/nsi/getnsitypeentries',
    getMpkListProjects: '/api/mpkproject/searchlight',
    getMpkProjectSearchLight: '/api/mpkproject/searchlight',
    getMpkProjectSearch: '/api/mpkproject/SearchWithArchiveData',
    getMpkProjectInvestmentsSum: '/api/mpkprojectv2/getinvestmentssum',
    getMpkCommissionSearch: '/api/mpkCommission/search',
    getUserProjectConfig: '/api/mpkproject/getuserprojectconfig',
    createUserProjectConfig: '/api/mpkproject/createuserprojectconfig',
    updateUserProjectConfig: '/api/mpkproject/updateuserprojectconfig',
  },
  mpkRating: {
    getMpkActivityDetail: '/api/mpkrating/getmpkactivitydetail',
    getLastTwoEventsForExecutiveDiscipline: '/api/mpkrating/getLastTwoEventsForExecutiveDiscipline',
  },
  mpkcochairman: {
    fetchCountries: 'api/mpkcochairman/findcountriescochairman',
  },
  admin: {
    statistics: {
      public: {
        getPagesTable: '/api/auditpublicstatistic/viewspagetable',
        getSectionsTable: '/api/auditpublicstatistic/viewspagesectionstable',
        getViewsCountByTimeTable: '/api/auditpublicstatistic/viewstable',
        getVisitsCountByTimeTable: '/api/auditpublicstatistic/visitstable',
        getVisitsCountByTimeChartData: '/api/auditpublicstatistic/visitschart',
        getViewsCountByTimeChartData: '/api/auditpublicstatistic/viewschart',
      },
      portal: {
        getVisitsCountByTimeChartData: '/api/auditportalstatistic/visitschart',
        getAverageVisitsTimeChartData: '/api/auditportalstatistic/averagevisittimechart',
        getUniqueVisitsCountChartData: '/api/auditportalstatistic/getuniqueuserschart',
        getViewsCountByTimeChartData: '/api/auditportalstatistic/viewschart',
        getVisitsCountByTimeTable: '/api/auditportalstatistic/visitstable',
        getVisitsCountByGroupsTable: '/api/auditportalstatistic/visitsbygroupstable',
        getVisitsCountByUsersTable: '/api/auditportalstatistic/visitsbyuserstable',
        getAverageVisitsTimeTable: '/api/auditportalstatistic/averagevisittimetable',
        getViewsCountByTimeTable: '/api/auditportalstatistic/viewstable',
        getUniqueVisitsCountTable: '/api/auditportalstatistic/getuniqueuserstable',
        getSectionsTable: '/api/auditportalstatistic/viewspagesectionstable',
        getPagesTable: '/api/auditportalstatistic/viewspagestable',
      },
    },
  },
  businessTip: {
    participants: '/api/mpkbusinesstip/participants',
    foreignParticipants: '/api/mpkbusinesstip/foreignparticipants',
  },
};
